const generateThumbnail = (file, buffer, heicBlob, targetWidth, targetHeight, orientation, thumbQuality) =>
  new Promise(resolve => {
    const windowURL = typeof window !== 'undefined' && (window.URL || window.webkitURL);
    const image = new Image();

    image.onload = () => {
      let canvas = document.createElement('canvas');
      canvas.width = targetWidth;
      canvas.height = targetHeight;

      const srcData = resize(image, targetWidth, targetHeight);
      const ctx = getOrientationAdjustedContext(canvas, orientation, targetWidth, targetHeight);
      const smallerWidth = srcData.width < targetWidth ? srcData.width : targetWidth;
      const smallerHeight = srcData.height < targetHeight ? srcData.height : targetHeight;
      const xDrawStart = smallerWidth === srcData.width ? (targetWidth - srcData.width) / 2 : 0; //if image is narrower than container, it needs horizontal centering
      const yDrawStart = smallerHeight === srcData.height ? (targetHeight - srcData.height) / 2 : 0; //if image is narrower than container, it needs vertical centering
      ctx.drawImage(image, srcData.x, srcData.y, srcData.width, srcData.height,
        xDrawStart, yDrawStart, smallerWidth, smallerHeight);

      const thumb = new Image();
      thumb.src = canvas.toDataURL('image/png', thumbQuality);
      canvas = null;
      windowURL.revokeObjectURL(image.src);

      resolve(thumb);
    };

    if (heicBlob) {
      image.src = windowURL.createObjectURL(heicBlob);
    } else {
      image.src = windowURL ? windowURL.createObjectURL(file) : buffer;
    }
  });

const resize = (image, toWidth, toHeight) => {
  const resizeData = {
    x: 0,
    y: 0,
    width: image.width,
    height: image.height
  };
  const srcRatio = image.width / image.height;
  const targetRatio = toWidth / toHeight;

  if (srcRatio > targetRatio) {
    resizeData.height = image.height;
    const newWidth = resizeData.height * targetRatio;
    //don't want to force crop on width if that will crop it smaller than toWidth
    if (newWidth > toWidth) { //if new width is big enough to fill min width requirement (toWidth)
      resizeData.width = newWidth;
    } else if (resizeData.width > toWidth) { //if new width will be too small, then if natural width is too big, lets use the desired toWidth size, otherwise well use natural width
      resizeData.width = toWidth;
    }
  } else {
    resizeData.width = image.width;
    const newHeight = resizeData.width / targetRatio;
    if (newHeight > toHeight) {
      resizeData.height = newHeight;
    } else if (resizeData.height > toHeight) {
      resizeData.height = toHeight;
    }
  }

  resizeData.x = (image.width - resizeData.width) / 2;
  resizeData.y = (image.height - resizeData.height) / 2;

  return resizeData;
};

const getOrientationAdjustedContext = (canvas, orientation, width, height) => {
  const canvasUsesOrientation = getComputedStyle(document.body)?.imageOrientation === 'from-image';

  const ctx = canvas.getContext('2d');

  if (!canvasUsesOrientation) {
    switch (orientation) {
      case 1:
        break;
      case 2:
        ctx.transform(-1, 0, 0, 1, width, 0);
        break;
      case 3:
        ctx.transform(-1, 0, 0, -1, width, height);
        break;
      case 4:
        ctx.transform(1, 0, 0, -1, 0, height);
        break;
      case 5:
        ctx.transform(0, 1, 1, 0, 0, 0);
        break;
      case 6:
        ctx.transform(0, 1, -1, 0, height, 0);
        break;
      case 7:
        ctx.transform(0, -1, -1, 0, height, width);
        break;
      case 8:
        ctx.transform(0, -1, 1, 0, 0, width);
        break;
    }
  }

  return ctx;
};

export default generateThumbnail;
